import AppConstants from '../../Constants/AppConstants';

export const paymentMethodDraftKey = id =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:payments:method:${id || 'new'}`;
export const readPaymentMethodDraft = key => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) { return {}; }
};
export const writePaymentMethodDraft = (key, state) => {
  const draft = {
    step: [1, 2, 3].includes(Number(state.step)) ? Number(state.step) : 1,
    status: Boolean(state.status),
    default: Boolean(state.default),
    name: String(state.name || '').slice(0, 300),
    note: String(state.note || '').slice(0, 2000),
    id: String(state.id || '').slice(0, 100),
    rank: String(state.rank || '').slice(0, 40),
    maximumAmount: String(state.maximumAmount || '').slice(0, 40),
    minimumAmount: String(state.minimumAmount || '').slice(0, 40),
    selectedPaymentMethod: String(state.selectedPaymentMethod || '').slice(0, 300),
    selectedPaymentMethodID: String(state.selectedPaymentMethodID || '').slice(0, 100),
    selectedPaymentMethodType: String(state.selectedPaymentMethodType || '').slice(0, 100),
    type: String(state.type || '').slice(0, 100),
  };
  try { window.localStorage.setItem(key, JSON.stringify(draft)); }
  catch (error) { /* Keep the editor usable when browser storage is unavailable. */ }
};
export const clearPaymentMethodDraft = key => {
  try { window.localStorage.removeItem(key); }
  catch (error) { /* Ignore storage errors after a successful save. */ }
};
